import { AndroidDeviceClient } from "../services/ohl.virtualCenter.api";

const apiClient = new AndroidDeviceClient(process.env.REACT_APP_PUBLIC_API);

class DevicesProvider {

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        if (params.filter && params.filter.assignType) {
            if (params.filter.assignType === 'all') {
                params.filter.assigned = true;
                params.filter.unassigned = true;
            } else if (params.filter.assignType === 'assigned') {
                params.filter.assigned = true;
                params.filter.unassigned = false;
            } else if (params.filter.assignType === 'unassigned') {
                params.filter.assigned = false;
                params.filter.unassigned = true;
            } else {
                params.filter.assigned = true;
                params.filter.unassigned = true;
            }
        }

        return apiClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }

    getOne = (resource, params) => {
        return apiClient.androidDeviceGet(params.id).then((data) => {
            return { data }
        });
    }

    update = (resource, params) => {
        return apiClient.androidDevicePut(params.data).then((data) => ({
            data
        }));
    }

    create = (resource, params) => {
        return apiClient.androidDevicePost(params.data).then((data) => ({
            data
        }));
    }

    delete = (resource, params) => {
        return apiClient.androidDeviceDelete(params.id).then(() => ({
            data: params.previousData
        }));
    }
};

export default new DevicesProvider();